import { EDA } from "motw_core/Dreams/EDreamAttribute";
import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Data from "source/app/services/Data";
import Nameof from "source/app/services/NameOf";
import IconWithText from "../../../../services/Shared/IconWithText/IconWithText";
import Render from "../../../Shared/Render";
import { ILogState } from "../../Log/ILogState";
import { DreamType } from "../DreamEditor/DreamType";
import { LaunchDreamEditor } from "../DreamEditor/Launch/Launch";
import DreamHelpers, { ExtendDream } from "../DreamHelpers/DreamHelpers";
import * as styles from "./DreamToolbar.css";

interface DreamToolbarProps {
    row: IDream;
    allDreams: IDream[];
    allLinks: IDream[];
    calledFrom: DreamToolbarCalledFrom;
}

export enum DreamToolbarCalledFrom {
    DreamPanel,
    DreamEditor,
}

const DreamToolbar = ({
    row,
    allDreams,
    allLinks,
    calledFrom,
}: DreamToolbarProps) => {
    const isDecisionDream = ExtendDream(row).HasAttribute(EDA.decision);

    return (
        <Render id="advancedOptions" withClasses={styles.toolbar} when={true}>
            <Render
                id="edit"
                when={calledFrom === DreamToolbarCalledFrom.DreamPanel}
            >
                <IconWithText
                    id="editIcon"
                    iconSuffix={EGlyphicon.pencil}
                    whenClicked={() =>
                        LaunchDreamEditor(DreamType.Existing, row, allDreams)
                    }
                    displayAsBlock={false}
                >
                    Edit
                </IconWithText>
            </Render>
            <IconWithText
                id="copyIcon"
                iconSuffix={EGlyphicon["resize-full"]}
                whenClicked={() =>
                    LaunchDreamEditor(DreamType.Copied, row, allDreams)
                }
                displayAsBlock={false}
            >
                Copy
            </IconWithText>
            <Render id="completeDreamLink" when={!isDecisionDream}>
                <IconWithText
                    id="completeIcon"
                    iconSuffix={EGlyphicon.ok}
                    whenClicked={async () => {
                        await DreamHelpers.DeleteDream(
                            row,
                            allLinks,
                            true,
                            true
                        );

                        await Data.Load.Single.ByStateTarget(
                            Nameof<ILogState>("logData")
                        );
                    }}
                    displayAsBlock={false}
                >
                    Complete
                </IconWithText>
            </Render>
            <IconWithText
                id="deleteIcon"
                iconSuffix={EGlyphicon["trash"]}
                whenClicked={() =>
                    DreamHelpers.DeleteDream(row, allLinks, true)
                }
                displayAsBlock={false}
            >
                Delete
            </IconWithText>
        </Render>
    );
};

export default DreamToolbar;
